import axios from '../axios'
import i18n from '../i18n'

const metadata = {
  namespaced: true,
  state: {
    error: null,
    loading: false,
    logo: '',
    tutorial: []
  },
  getters: {
    isLoading: function (state, getters, rootState, rootGetters) {
      return state.loading
    }
  },
  actions: {
    async fetchTutorial (context) {
      context.commit('setLoading', { loading: true })
      try {
        let file
        let i
        for (i = 0; i < 5; i++) {
          if (i === 0) file = 'ManualAduan.pdf'
          if (i === 1) file = 'ManualCadangan.pdf'
          if (i === 2) file = 'ManualCukaiPintuKompaun.pdf'
          if (i === 3) file = 'ManualLesen.pdf'
          if (i === 4) file = 'ManualApplyTrading.pdf'
          const response = await axios.get(`/getAttachments/metadata/tutorial/${file}`, {
            responseType: 'blob'
          })
          response.data.title = file
          context.commit('setTutorial', { tutorial: response.data })
          context.commit('setError', { error: null })
        }
      } catch (error) {
        context.commit('setError', { error: error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
      } finally {
        context.commit('setLoading', { loading: false })
      }
    },
    fetchLogoBase64: async function (context, payload = {}) {
      context.commit('setLoading', { loading: true })
      try {
        const response = await axios.get(`/getAttachments/metadata/logo/${payload.council ? payload.council : 'sabah'}.png`, { responseType: 'arraybuffer' })
        const base64logo = 'data:image/png;base64,' + Buffer.from(response.data, 'binary').toString('base64')
        context.commit('setLogo', base64logo)
        return base64logo
      } catch (error) {
        context.commit('setError', { error })
        this.dispatch('snackbar/setSnackBar', {
          color: 'error',
          message: i18n.t('fetching_data_failed'),
          visible: true
        })
        throw error
      } finally {
        context.commit('setLoading', { loading: false })
      }
    }
  },
  mutations: {
    setError: function (state, payload) {
      state.error = payload.error
    },
    setLoading: function (state, payload) {
      state.loading = payload.loading
    },
    setLogo: function (state, payload = '') {
      state.logo = payload
    },
    setTutorial (state, payload) {
      state.tutorial.push(payload.tutorial)
    }
  }
}

export default metadata
